import React from 'react';

const ClearIndicator = (props) => {
	const {
		children = <img src="/images/cross.svg" />,
		getStyles,
		innerProps: { ref, ...restInnerProps },
	} = props;
	return (
		<div
			{...restInnerProps}
			ref={ref}
			style={getStyles('clearIndicator', props)}
		>
			<div>{children}</div>
		</div>
	);
};

export default ClearIndicator;
